module.exports = __webpack_public_path__ + "static/media/stop-2.60340725.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-2.svg
// module id = 1347
// module chunks = 0